/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SmyTab.vue?vue&type=template&id=3b83f45e&scoped=true&lang=html&"
import script from "./SmyTab.vue?vue&type=script&lang=js&"
export * from "./SmyTab.vue?vue&type=script&lang=js&"
import style0 from "./SmyTab.vue?vue&type=style&index=0&id=3b83f45e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b83f45e",
  null
  
)

export default component.exports